import React from 'react';
import './style.scss';
import { Check } from '../../../atoms/icons';

interface Component {
  label: string;
  component: React.ReactElement;
}

interface Props {
  components: Component[];
  step: number; /* should be start from 0 */
  onClick?: React.Dispatch<React.SetStateAction<number>> | undefined;
  componentClassName?: string
}

const Kebab:React.FC<Props> = (props) => {
  const {
    step, components, onClick, componentClassName,
  } = props;
  return (
    <div className="w-100">
      <div className="stepper-kebab-container">
        <div className="line-container">
          <div className="line" />
        </div>
        {components.map((component, i) => (
          <div className="content-box" key={component.label}>
            <div className="text">{component.label}</div>
            <button
              type="button"
              className="dot"
              onClick={onClick ? () => onClick(i) : undefined}
              disabled={!onClick}
            >
              <div style={{ marginTop: '1px' }} className={step > i ? '' : 'd-none'}>
                <Check />
              </div>
              <div className={step < i ? '' : 'd-none'}>
                <div className="white-dot" />
              </div>
            </button>
          </div>
        ))}
      </div>
      <div className={componentClassName}>
        {components[step].component}
      </div>
    </div>
  );
};

export default Kebab;
